<template>
  <!-- this template is just for copy & paste -->
  <form @submit.prevent="submit()">
    <v-card>
      <v-card-title class="headline">{{}}</v-card-title>
      <v-card-text> </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-spacer />
          <v-btn
            type="button"
            text
            color="grey darken-2">
            cancel
          </v-btn>
          <v-btn
            type="submit"
            text
            color="primary darken-2">
            OK
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </form>
</template>
<script>
import { mixForm } from '@/utils/form.mix.js'
export default {
  name: 'FormAbstract',
  mixins: [mixForm]
}
</script>
